import { STRAIN_ORDER } from '@/constants';
import { RefinementListItem } from 'opensearch/types';

const strainOrderIndex = new Map(
  STRAIN_ORDER.map((label, index) => [label.toLowerCase(), index]),
);

export const sortByClassificationFilter = (values: RefinementListItem[]) =>
  [...values].sort((a, b) => {
    const indexA = strainOrderIndex.get(a.label.toLowerCase());
    const indexB = strainOrderIndex.get(b.label.toLowerCase());

    return (indexA ?? Infinity) - (indexB ?? Infinity);
  });

export const ordenFilterItems = (
  items: RefinementListItem[],
  attribute: string,
): RefinementListItem[] => {
  const applyClassificationSort = attribute === 'classification';

  if (applyClassificationSort) {
    return sortByClassificationFilter(items);
  }

  return [...items].sort(({ label: a }, { label: b }) =>
    a.toLowerCase().localeCompare(b.toLowerCase()),
  );
};
